// extracted by css-extract-rspack-plugin
export default {"container":"container-WIc5G1","header":"header-FKyX_r"};